import {
  Datagrid,
  Filter,
  List,
  SaveButton,
  SearchInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  useTranslate,
  useRecordContext,
} from 'react-admin'

import { DialogForm } from '../components/DialogForm'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton {...props} type="submit" />
  </Toolbar>
)

export const BankAccountEditDialog = (props) => {
  const translate = useTranslate()
  const record = useRecordContext()
  if (!record) return null

  return (
    <DialogForm
      title={translate('hs.compliance.bank_account.title', {
        copro_code: record.copro_code,
      })}
      id={record.id}
    >
      <SimpleForm
        resource="compliance/bank_account"
        basePath="/"
        toolbar={<SaveOnlyToolbar {...props} />}
        redirect={false}
      >
        <TextInput source="current_account_bank_id" />
        <TextInput source="works_account_bank_id" />
        <TextInput source="credit_id" />
      </SimpleForm>
    </DialogForm>
  )
}

const BankAccountListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

export const BankAccountList = (props) => (
  <List
    {...props}
    exporter={false}
    hasCreate={false}
    perPage={100}
    filters={<BankAccountListFilter />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="copro_code" />
      <TextField source="current_account_bank_id" />
      <TextField source="works_account_bank_id" />
      <TextField source="credit_id" />
      <BankAccountEditDialog />
    </Datagrid>
  </List>
)
